let w = window.innerWidth;
if (w < 768) {
    document.querySelectorAll('.profile-our-txt').forEach(function(item,index) {
        const txt = item.querySelector('.txt');
        var txt_split = txt.innerHTML.split(' ');
        
        var show_txt = '';
        var hidden_txt = '';
        txt_split.forEach(function(item,index) {
            if (index <= 25){
                show_txt += `${item} `;
            } else if (index >= 25){
                hidden_txt += `${item} `;
            }
        });
        txt.innerHTML = `<span class="show-txt">${show_txt}</span><span class="hidden-txt">${hidden_txt}</span>`;

        item.querySelector('[data-readmorebtn]').addEventListener('click', event => {
            event.preventDefault();
            if (event.target.innerHTML == 'Read More'){
                event.target.innerHTML = 'Read Less';
                event.target.closest('.profile-our-txt').querySelector('.txt .hidden-txt').style.display = 'inline';

            } else if (event.target.innerHTML == 'Read Less'){
                event.target.innerHTML = 'Read More';
                event.target.closest('.profile-our-txt').querySelector('.txt .hidden-txt').style.display = 'none';
            }
        }); 
    });
}